import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  allowedTracingUrls: [process.env.REACT_APP_API_URL, process.env.REACT_APP_CORE_API_URL],
  applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
  clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: process.env.REACT_APP_DD_SERVICE,
  env: process.env.REACT_APP_DD_ENV,
  version: process.env.REACT_APP_DD_VERSION,
  sessionSampleRate: Number(process.env.REACT_APP_DD_SAMPLE_RATE),
  sessionReplaySampleRate: Number(process.env.REACT_APP_DD_REPLAY_SAMPLE_RATE),
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input'
});
